import React from 'react';
import { connect } from 'react-redux';
import {
  TasksSidebarList,
  Checkbox,
  LoadingSpinner,
  DatePicker
} from 'components';
import { Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import Select from 'react-select';
import moment from 'moment';

// Kind of a hack to deal with tasks getting fetched
//  after component mounts (want entire tasks list as default)
let _tasks_filter_changed = false;

class TasksFilters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // Based on the date range
      date_range_min: new Date(),
      date_range_max: new Date(),
      show_all_task_dates: true,
      selected_client: null,
      show_assigned_by_me: false,
      show_completed: false
    };

    this.getFilteredTasks = this.getFilteredTasks.bind(this);
    this.handleDateRangeChange = this.handleDateRangeChange.bind(this);
    this.toggleShowAllDates = this.toggleShowAllDates.bind(this);
    this.toggleAssignedByMe = this.toggleAssignedByMe.bind(this);
    this.toggleShowCompleted = this.toggleShowCompleted.bind(this);
    this.handleClientFilterChange = this.handleClientFilterChange.bind(this);
  }

  getFilteredTasks() {
    const min_date = moment(this.state.date_range_min).startOf('day').toDate();
    const max_date = moment(this.state.date_range_max).endOf('day').toDate();
    const tasks = this.state.show_assigned_by_me ?
    this.props.tasks.assigned_by_me :
    this.props.tasks.assigned_to_me;

    const filtered_task_ids = (
      this.state.show_all_task_dates ?
      tasks :
      tasks.filter(t => {
        const due_date = new Date(t.due_date);
        return due_date >= min_date && due_date <= max_date;
      }))
      .filter(t => this.state.selected_client ? t.client && t.client._id == this.state.selected_client : true)
      .filter(t => this.state.show_completed ? t.completed == true : t.completed == false)

    return filtered_task_ids;
  }
  handleDateRangeChange(range) {
    if(range.length > 0) {
      this.setState({
        date_range_min: new Date(range[0]),
        date_range_max: new Date(range[1]),
        show_all_task_dates: false
      });
    }
  }
  toggleShowAllDates() {
    this.setState({ show_all_task_dates: !this.state.show_all_task_dates });
  }
  toggleAssignedByMe(bool) {
    if(this.state.show_assigned_by_me != bool) {
      this.setState({ show_assigned_by_me: bool });
    }
  }
  toggleShowCompleted(bool) {
    if(this.state.show_completed != bool) {
      this.setState({ show_completed: bool });
    }
  }
  handleClientFilterChange(client) {
    const client_id = client ? client.value : null;
    this.setState({ selected_client: client_id });
  }
  componentWillMount() {
    const now = Date.now();
		const hour = 1000 * 60 * 60;
	  const day = 24 * hour;
	  const one_week = now + day * 7;

    this.setState({
      date_range_min: now,
      date_range_max: one_week
    });
  }

  render() {
    const clients_list = [ ...this.props.tasks.assigned_by_me, ...this.props.tasks.assigned_to_me ]
    .filter(t => t.client != null)
    .map(t => ({ value: t.client._id, label: t.client.name }));

    const clients_set = Array
    .from(new Set(clients_list.map(c => c.value)))
    .map(client_id => ({ value: client_id, label: clients_list.find(({ value }) => value == client_id).label }));

    const tasks_list = this.getFilteredTasks();

    return (
      <div className='tasks-filters-container'>
        <div className='tasks-filters-calendar-container task-calendar'>
          <DatePicker
            dark
            weekNumbers={false}
            onRangeChange={this.handleDateRangeChange}
            defaultRange={[]}
            highlightRangeOnMouseMove={true}
          />
        </div>
        <Row>
          <Col md={12} xs={12} className='tasks-filters-check-box-container'>
            <div>
              <Checkbox
                checked={this.state.show_all_task_dates}
                onChange={this.toggleShowAllDates}
              />
            </div>
            <p>Show All Due Dates{'  '}</p>
          </Col>
        </Row>
        <Row className='mb-md mt-md'>
          <Col xs={12} md={12}>
            <Select
              options={clients_set}
              value={this.state.selected_client}
              onChange={this.handleClientFilterChange}
              placeholder='Filter By Client...'
            />
          </Col>
        </Row>
        <Row className='mb-md'>
          <Col md={12} xs={12}>
            <ButtonGroup bsSize='small' justified>
              <Button
                bsStyle={!this.state.show_assigned_by_me ? 'primary' : 'default'}
                onClick={() => this.toggleAssignedByMe(false)}
                >
                Assigned To Me
              </Button>
              <Button
                bsStyle={this.state.show_assigned_by_me ? 'primary' : 'default'}
                onClick={() => this.toggleAssignedByMe(true)}
                >
                Assigned By Me
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
        <Row className='mb-md'>
          <Col md={12} xs={12}>
            <ButtonGroup bsSize='small' justified>
              <Button
                bsStyle={!this.state.show_completed ? 'primary' : 'default'}
                onClick={() => this.toggleShowCompleted(false)}
                >
                Incomplete
              </Button>
              <Button
                bsStyle={this.state.show_completed ? 'primary' : 'default'}
                onClick={() => this.toggleShowCompleted(true)}
                >
                Complete
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
        {this.props.tasks.initializing_tasks ?
        <LoadingSpinner /> :
        <TasksSidebarList
          tasks={tasks_list}
          show_assigned_by_me={this.state.show_assigned_by_me}
          initEditTask={task => this.props.initEditTask(task)}
          initEditReminderDate={task => this.props.initEditReminderDate(task)}
        />}
      </div>
    );
  }
}

const mapStateToProps = ({ tasks, clients }) => ({ tasks, clients });

export default connect(mapStateToProps)(TasksFilters);



// WEBPACK FOOTER //
// ./src/browser/components/tasks/new-tasks/tasks-filters.js